import EditorConnected from './EditorConnected'
export default EditorConnected
